import { FunctionComponent, useContext, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import contextLayoutMultiLine from '@contexts/layoutMultiLine'
import { mobileCSS } from '@measures/responsive'

interface StyledWrapperProps {
  isInsideVideoBlock: boolean
}

const { LayoutMultiLineContext } = contextLayoutMultiLine

const StyledWrapper = styled.div<StyledWrapperProps>`
  position: relative;

 ${mobileCSS(` 
  padding: 0 0 56.25%; 
  `)}
    
};
`

const StyledContainer = styled.div`
  ${() => {
    const mobileStyles = `
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    `
    return css`
      position: relative;
      ${mobileCSS(mobileStyles)}
    `
  }};
`

const BlickTVTeaserWrapper: FunctionComponent<{
  children: ReactNode
}> = ({ children }) => {
  const layoutMultilineContext = useContext(LayoutMultiLineContext)

  return (
    <StyledWrapper isInsideVideoBlock={!!layoutMultilineContext?.isVideoBlock}>
      <StyledContainer>{children}</StyledContainer>
    </StyledWrapper>
  )
}

export default BlickTVTeaserWrapper
